import { Pipe, PipeTransform } from '@angular/core';
import { getCurrencySymbol } from '@angular/common';

@Pipe({
  name: 'dynamicCurrency',
  standalone: false
})

export class DynamicCurrencyPipe implements PipeTransform { 
  braintreeCurrencyConversion: number = 1;
  taxLabel: string = '';
  taxRate: number = 1;

  transform(value: number, currencyCode: string, locale?: string): string {
    const symbol = getCurrencySymbol(currencyCode, 'narrow', locale);

    switch (currencyCode) {
      case 'CAD':
        this.braintreeCurrencyConversion = 1.38;
        return `${symbol}${(value * this.braintreeCurrencyConversion).toFixed(2)}`;

      case 'GBP':
        this.braintreeCurrencyConversion = 0.83;
        this.taxLabel = 'w/ VAT';
        this.taxRate = 1.2; //later: dynamically update rate from checkout page based on country/city/zip
        return `${symbol}${(value * this.braintreeCurrencyConversion * this.taxRate).toFixed(2)}`;

      case 'AUD':
        this.braintreeCurrencyConversion = 1.52;
        this.taxLabel = 'w/ GST';
        this.taxRate = 1.1; //later: dynamically update rate from checkout page based on country/city/zip
        return `${symbol}${(value * this.braintreeCurrencyConversion * this.taxRate).toFixed(2)}`;

      default:
        return `${symbol}${(value * this.braintreeCurrencyConversion).toFixed(2)}`;
    }
  }
  
  checkPriceWithTax(currencyCode: string): boolean {
    return ['AUD', 'GBP'].includes(currencyCode);
  }
}